import { logger } from "../logger";
var NativeStorage = /** @class */ (function () {
    function NativeStorage(type) {
        var _this = this;
        this.json_prefix = "__json=";
        this.isBrowser = typeof window !== "undefined";
        this.memoryStorage = {};
        this.storageName = type;
        if (!this.isBrowser) {
            // Create an in-memory storage for SSR
            this.storage = {
                getItem: function (key) { return _this.memoryStorage[key] || null; },
                setItem: function (key, value) {
                    _this.memoryStorage[key] = value;
                },
                removeItem: function (key) {
                    delete _this.memoryStorage[key];
                },
                clear: function () {
                    _this.memoryStorage = {};
                },
                key: function (index) { return Object.keys(_this.memoryStorage)[index] || null; },
                length: 0,
            };
            return;
        }
        switch (type) {
            case "sessionStorage":
                this.storage = sessionStorage;
                break;
            case "localStorage":
                this.storage = localStorage;
                break;
        }
    }
    NativeStorage.prototype.isAvailable = function () {
        return this.isBrowser;
    };
    NativeStorage.prototype.set = function (key, value) {
        if (typeof value === "boolean")
            value = value === true ? "true" : "false";
        if (typeof value === "object")
            value = this.json_prefix + JSON.stringify(value);
        this.storage.setItem(key, value);
    };
    NativeStorage.prototype.get = function (key) {
        var value = this.storage.getItem(key);
        if (!value || typeof value !== "string")
            return null;
        if (["null", "undefined"].some(function (item) { return item == value; }))
            return null;
        if (value.startsWith(this.json_prefix)) {
            try {
                return JSON.parse(value.slice(7));
            }
            catch (error) {
                logger.error("[FORMO_ERROR] ".concat(this.storageName, " failed to parse JSON"), error);
                return null;
            }
        }
        if (["true", "false"].some(function (item) { return item == value; })) {
            return JSON.parse(value);
        }
        return value;
    };
    NativeStorage.prototype.removeMatch = function (pattern) {
        for (var key in this.storage) {
            if (pattern.test(key)) {
                this.remove(key);
            }
        }
    };
    NativeStorage.prototype.remove = function (key) {
        this.storage.removeItem(key);
    };
    NativeStorage.prototype.clear = function () {
        this.storage.clear();
    };
    return NativeStorage;
}());
export { NativeStorage };
export default NativeStorage;
//# sourceMappingURL=native.js.map